import { Form, Layout, PageWrap } from "@vwfs-bronson/bronson-react";
import { Transmission } from "../components/question-3/Transmission";
import { Power } from "../components/question-3/Power";
import { Equipment } from "../components/question-3/Equipment";
import { WizardButtons } from "../components/ui/WizardButtons";
import { Formik } from "formik";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { getMaxPower, getMinPower } from "../data/contract";
import { Step, SubmitAnswersRequest } from "../interfaces";
import { SaveAndContinue } from "../components/save-and-continue/SaveAndContinue";

export const Question3Page = () => {
    const { submitAnswersRequest, setSubmitAnswersRequest, isEdit } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;
    return (
        <>
            <Formik
                initialValues={{
                    transmissionType: matchMakerAnswers?.transmissionType ?? undefined,
                    minPower: matchMakerAnswers?.minPower ?? undefined,
                    maxPower: matchMakerAnswers?.maxPower ?? undefined,
                    optionals: matchMakerAnswers?.optionals ?? undefined,
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    if (!values.minPower) values.minPower = getMinPower();
                    if (!values.maxPower) values.maxPower = getMaxPower();
                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            matchMakerAnswers: {
                                ...matchMakerAnswers,
                                ...values,
                            },
                            isEditMode: isEdit,
                            currentStep: Step.MM3,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps) => (
                    <Form id="Question3PageForm" onSubmit={formikProps.handleSubmit} noValidate>
                        <Layout className="u-mt-xsmall" flush>
                            <Layout.Item>
                                <PageWrap className="u-text-center u-mb u-mt" size="small">
                                    <Transmission />
                                    <hr className="u-mv-large" />
                                    <Power />
                                    <hr className="u-mv-large" />
                                    <Equipment />
                                </PageWrap>
                            </Layout.Item>
                            <Layout.Item className="u-mt">
                                <WizardButtons />
                            </Layout.Item>
                        </Layout>
                    </Form>
                )}
            </Formik>
            <SaveAndContinue />
        </>
    );
};
